const ORGANIZATION_API_BASE_URL = "/organizations";

export const ORGANIZATION_API_ENDPOINTS = { GET_ORGANIZATION: (organizationId: string) => `${ORGANIZATION_API_BASE_URL}/${organizationId}` } as const;
